import { render, staticRenderFns } from "./MyBots.vue?vue&type=template&id=1319fce1&"
import script from "./MyBots.vue?vue&type=script&lang=js&"
export * from "./MyBots.vue?vue&type=script&lang=js&"
import style0 from "./MyBots.vue?vue&type=style&index=0&id=1319fce1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports